/** @jsxImportSource theme-ui */
import { Container, Box, Grid, Flex } from 'theme-ui';
import { useNavigate } from 'react-router-dom';
import VossUsage from '@/containers/voss/Usage';
import Button from '@/components/Button';

const VossUsagePage = () => {
    let navigate = useNavigate();
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <VossUsage />
            </Flex>
        </Container>
    );
};

export default VossUsagePage;
